import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import { useAuth } from "../../../context/auth-context";
import { rootUrl } from "../../../helpers";
import DataTable from "react-data-table-component";
import { FaEye, FaMoneyBill, FaPlus } from "react-icons/fa";
import SlidingDiv from "../../../components/SlidingDiv";
import SupplierStatement from "./SupplierStatement";
import { useOutletContext } from 'react-router-dom';
import AddBillModal from "../bills/addBill";
import { toast } from "react-toastify";

const SupplierManagement = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [title, setTitle] = useState('');
  const [output, setOutput] = useState('');
  const [formType, setFormType] = useState(1); // 1: Invoice, 2: Payment
  const [formData, setFormData] = useState({
    name: "",
    contactPerson: "",
    phoneNumber: "",
    email: "",
    address: "",
  });

  const auth = useAuth();

  
  const [isSlidingDivOpen, setIsSlidingDivOpen] = useState(false);

  const toggleSlidingDiv = () => setIsSlidingDivOpen(!isSlidingDivOpen);


  useEffect(() => {
    axios.get(rootUrl(`/getSuppliers/${auth.user.id}`)) 
      .then((response) => setSuppliers(response.data.data))
      .catch((error) => console.error("Error fetching suppliers:", error));
  }, []);

  // Handle form changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle modal open/close
  const toggleModal = () => setIsModalOpen((prev) => !prev);

  // Submit handler
  const handleSubmit = () => {
    formData['uid'] = auth.user.id;
      axios.post(rootUrl("/addSupplier"), formData)
        .then(() => {
          toast.success("Successful")
          toggleModal();
        })
        .catch((error) => console.error("Error submitting invoice:", error));
    
  };

  const allData = useOutletContext();

  function viewSupp(id, type, name){

    toggleSlidingDiv()

    if(type === 1){
      setTitle('Supplier Statement')
      setOutput(<SupplierStatement id={id} name={name} />)
    }

    if(type === 2){
      setTitle('Add Statement')
      setOutput(<AddBillModal data={allData} onSubmit={onSubmit} type={2} />)
    }
  }


  
  const onSubmit = async (payload)=>{
    payload['uid'] = auth.user.id
    try{
        const response = await axios.post(rootUrl('/paySupplier'), payload)
        if(response.data.status === 200){
            toast.success("Submitted successfully")
            setIsSlidingDivOpen(false)
        }else{
            toast.error("Something went wrong")
        }
    }catch(e){
        toast.error(e?.message)
    }
}


  const columns = [
    {
      name: "Sn",
      selector: (row, index) => index + 1,
      width: "50px",
      center: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
  
    {
      name: "Actions",
      cell: (row) => (
        <>
                {/*     <button onClick={()=>addPay(row.id, 2)} className="text-blue-500 underline m-2 text-lg"> <FaFileLines/> </button> */}
                <button onClick={()=>viewSupp(row.id, 1, row.name)} className="bg-blue-900 text-white px-2 py-2 rounded-lg m-2 text-lg"> <FaEye/> </button>
        </>
        
      ),
      button: true,
      center: true,
    },
  ];
  
  const filteredData = suppliers.filter(supplier =>
    supplier.name.toLowerCase().includes(searchQuery.toLowerCase())
);

  return (
    <div className="w-full flex flex-col bg-white min-h-[400px] rounded-md mt-10 p-5">
      {/* Header */}
      <div className="flex w-full items-center justify-between border-b pb-4">
        <div>
          <h1 className="text-[25px] text-slate-800 font-bold">Suppliers</h1>
          <span className="text-[12px] text-slate-700">All supplier info</span>
        </div>
        <div className="flex items-center">
          
          {/* Add Supplier Button */}

          <button onClick={()=>viewSupp(1, 2)} 
          className="text-blue-900 border h-[40px] px-3 ml-2 m-2 text-lg flex items-center rounded-lg"> <FaMoneyBill/> Pay</button>
          <button
            onClick={toggleModal}
            className="flex items-center btn bg-blue-900 text-white items-center border border-gray-300 h-[40px] px-3 ml-2 rounded-lg text-[12px]"
          >
            <FaPlus/>
            New 
          </button>
        </div>
      </div>

      {/* Supplier Table */}
      <div id="supTable">
       
      <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)} // Update search query state
                className="my-4 p-2 border border-gray-300 rounded"
            />
     
      <DataTable
                title=""
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                striped
                responsive
            />

      </div>



      <SlidingDiv
        isOpen={isSlidingDivOpen}
        onClose={toggleSlidingDiv}
        title={title}
        children = {output}
      /> 
      
     

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
          <div className="bg-white rounded p-5 w-[60%] shadow-lg">
            {/* Modal Header */}
            <div className="flex justify-between items-center mb-4 border-b pb-4">
              <h2 className="text-xl font-semibold">
                {selectedSupplier ? "Edit Supplier" : "Add New Supplier"}
              </h2>
              <button
                onClick={toggleModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
            {/* Modal Body */}
            <div className="grid grid-cols-2 gap-4">
              <input
                name="name"
                placeholder="Supplier Name"
                value={formData.name}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="contactPerson"
                placeholder="Contact Person"
                value={formData.contactPerson}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              <input
                name="address"
                placeholder="Address"
                value={formData.address}
                onChange={handleInputChange}
                className="border rounded p-2"
              />
              {/* Other fields based on form type */}
              {formType === 2 && (
                <>
                  <Select
                    name="budget"
                    placeholder="Select Budget"
                    options={[]} // Populate options dynamically
                    onChange={(option) =>
                      setFormData((prev) => ({ ...prev, budget: option.value }))
                    }
                  />
                  <textarea
                    name="description"
                    placeholder="Description"
                    value={formData.description}
                    onChange={handleInputChange}
                    className="border rounded p-2 col-span-2"
                  />
                </>
              )}
            </div>
            {/* Modal Footer */}
            <div className="flex justify-end mt-4">
              <button
                onClick={toggleModal}
                className="bg-gray-100 text-gray-700 px-4 py-2 rounded"
              >
                Close
              </button>
              <button
                onClick={handleSubmit}
                className="bg-blue-500 text-white px-4 py-2 rounded ml-2"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SupplierManagement;
